let overrideDepth = 0

export function runWithEditorContentReplaceOverride(action: () => void): void {
  overrideDepth += 1
  try {
    action()
  } finally {
    overrideDepth = Math.max(0, overrideDepth - 1)
  }
}

export function isEditorContentReplaceOverrideActive(): boolean {
  return overrideDepth > 0
}

export function resetEditorContentReplaceOverrideForTests(): void {
  overrideDepth = 0
}
